module.exports = __webpack_public_path__ + "img/59.6e64c6ac.jpg";